import Component from '@glimmer/component'
import t from 'ember-intl/helpers/t'
import Icon from 'customer-flows/components/ui-kit/icon'
import { context } from 'customer-flows/utils/core'

export default class OrderSummary extends Component {
  @context('program/booking-flow') hideDateTime: BookingFlowStore['hideDateTime']
  @context('quote/booking-quote') selectedDateTimeDuration: BookingQuoteStore['selectedDateTimeDuration']
  @context('quote/booking-quote') getActivitySnapshot: BookingQuoteStore['getActivitySnapshot']
  @context('quote/booking-quote') getLines: BookingQuoteStore['getLines']
  @context('order') displayId: OrderStore['displayId']

  get activityName() {
    return this.getActivitySnapshot()?.name
  }

  get orderItems() {
    return this.getLines().map((line: QuoteLine) => `${line.quantity}x ${line.description}`).join(', ')
  }

  <template>
    <il-card data-testid='order-summary' type='theme'>
      <div slot='section' class='flex flex-col gap-3'>
        <il-list-item header={{this.activityName}} />

        <div data-testid='order-summary__order-details' class='flex flex-col gap-2'>
          {{#unless this.hideDateTime}}
            <il-list-item>
              <div data-testid='order-summary__date-time' class='flex items-center gap-2 text-component-bold-para-14'>
                <Icon @src='calendar' />
                <span>{{this.selectedDateTimeDuration}}</span>
              </div>
            </il-list-item>
          {{/unless}}
          <il-list-item>
            <div class='flex items-center gap-2 text-component-bold-para-14'>
              <Icon @src='resource' />
              <span>{{this.orderItems}}</span>
            </div>
          </il-list-item>
          <il-list-item>
            <div class='flex items-center gap-2 text-component-bold-para-14'>
              <Icon @src='hashtag' />
              <span data-testid="order-summary__order-id">{{t 'confirmation.order-id' orderId=this.displayId}}</span>
            </div>
          </il-list-item>
        </div>
      </div>
    </il-card>
  </template>
}
